(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3123],{

/***/ 53123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content049": function() { return /* binding */ Content049; },
  "default": function() { return /* binding */ Content049_Content049; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/widgets/content/Content049/Item/Item.module.scss
var Item_module = __webpack_require__(43634);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content049/Item/Item.jsx







var Item = function(param) {
    var item = param.item;
    var locale = (0,router.useRouter)().locale;
    var date = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(item.date, locale);
    }, [
        item.date,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Item_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
            link: item === null || item === void 0 ? void 0 : item.course,
            className: (Item_module_default()).link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Item_module_default()).item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Item_module_default()).text,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                                className: (Item_module_default()).title,
                                color: "dark",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                className: (Item_module_default()).description,
                                value: item.description
                            }),
                            item.showDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                color: "grey",
                                children: date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Item_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Item_module_default()).arrow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                className: (Item_module_default()).icon,
                                name: "arrow_right"
                            })
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content049/Item/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content049/BlockView/BlockView.module.scss
var BlockView_module = __webpack_require__(20106);
var BlockView_module_default = /*#__PURE__*/__webpack_require__.n(BlockView_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content049/BlockView/BlockView.jsx








var BlockView = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var pointsTitle = (ref2 = payload === null || payload === void 0 ? void 0 : payload.pointsTitle) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var points = (ref3 = payload === null || payload === void 0 ? void 0 : payload.points) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    var courses = (ref4 = payload === null || payload === void 0 ? void 0 : payload.courses) !== null && ref4 !== void 0 ? ref4 : [];
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var ref5 = (0,hooks/* useToggle */.OT)(), opened = ref5.opened, onToggle = ref5.onToggle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BlockView_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (BlockView_module_default()).blocks,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BlockView_module_default()).block,
                    children: [
                        !isDesktop && courses.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((BlockView_module_default()).dropdown, (0,_define_property/* default */.Z)({}, (BlockView_module_default()).opened, opened)),
                            onClick: onToggle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                name: "dropdown",
                                className: (BlockView_module_default()).icon
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (BlockView_module_default()).title,
                            color: "dark",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: (BlockView_module_default()).description,
                            color: "dark",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* RenderIf */.$b, {
                            viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    className: (BlockView_module_default())["points-title"],
                                    color: "dark",
                                    uppercase: true,
                                    appearance: "bigger",
                                    children: pointsTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrderedList */.GS, {
                                    items: points,
                                    className: (BlockView_module_default()).points
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BlockView_module_default()).block,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                            viewMode: ViewMode/* VIEW_MODES.MOBILE */.nY.MOBILE,
                            children: opened && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BlockView_module_default()).courses,
                                children: courses.map(function(course) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                        item: course
                                    }, course.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                            viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BlockView_module_default()).courses,
                                children: courses.map(function(course) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                        item: course
                                    }, course.id);
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content049/BlockView/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content049/Content049.module.scss
var Content049_module = __webpack_require__(51893);
var Content049_module_default = /*#__PURE__*/__webpack_require__.n(Content049_module);
// EXTERNAL MODULE: ./src/components/widgets/content/Content049/ListView/ListView.module.scss
var ListView_module = __webpack_require__(54140);
var ListView_module_default = /*#__PURE__*/__webpack_require__.n(ListView_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content049/ListView/ListView.jsx







var ListView = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var courses = (ref2 = payload === null || payload === void 0 ? void 0 : payload.courses) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3 = (0,hooks/* useToggle */.OT)(), opened = ref3.opened, onToggle = ref3.onToggle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ListView_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((ListView_module_default()).dropdown, (0,_define_property/* default */.Z)({}, (ListView_module_default()).opened, opened)),
                onClick: onToggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ListView_module_default()).top,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                        className: (ListView_module_default()).title,
                        color: "dark",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (ListView_module_default()).description,
                        color: "dark",
                        children: description
                    })
                ]
            }),
            opened && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ListView_module_default()).projects,
                children: courses.map(function(courses) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                        link: courses === null || courses === void 0 ? void 0 : courses.course,
                        className: (ListView_module_default()).link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ListView_module_default()).project,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                                    className: (ListView_module_default())["project-title"],
                                    color: "dark",
                                    children: courses.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ListView_module_default())["project-description"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                            value: courses.description,
                                            className: (ListView_module_default()).description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ListView_module_default()).button,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: (ListView_module_default()).icon,
                                                name: "large_arrow_right"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, courses.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content049/ListView/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content049/Content049.jsx





var Content049 = function(param) {
    var payload = param.payload;
    var ref;
    var template = (ref = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref !== void 0 ? ref : "blocks";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content049_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: template === "blocks" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockView, {
                payload: payload
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ListView, {
                payload: payload
            })
        })
    });
};
/* harmony default export */ var Content049_Content049 = (Content049);


/***/ }),

/***/ 20106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockView_wrapper___b9RO","blocks":"BlockView_blocks__pRnr5","block":"BlockView_block__h42tD","title":"BlockView_title__kzVMQ","description":"BlockView_description__b0wLv","points-title":"BlockView_points-title__fLj7w","points":"BlockView_points__xFPNi","courses":"BlockView_courses__LyIlv","dropdown":"BlockView_dropdown__j14TF","icon":"BlockView_icon__OYISp","opened":"BlockView_opened__FE6gW"};

/***/ }),

/***/ 51893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content049_wrapper__DFUW2"};

/***/ }),

/***/ 43634:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__14Ise","item":"Item_item__6McEE","text":"Item_text__MDRKg","link":"Item_link__oFZsO","title":"Item_title__yY7El","description":"Item_description__pq8Ia","button":"Item_button__9VDub","arrow":"Item_arrow__lfQ1o","icon":"Item_icon__UEQsc"};

/***/ }),

/***/ 54140:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListView_wrapper__Z6u4R","top":"ListView_top__0KIM3","button":"ListView_button__8Gawb","icon":"ListView_icon__UmOTU","link":"ListView_link__3PFFB","project":"ListView_project__32zsm","project-description":"ListView_project-description__buCh_","dropdown":"ListView_dropdown__mfpXX","opened":"ListView_opened__7zUm4","description":"ListView_description__nDROi","title":"ListView_title__a3sAH","project-title":"ListView_project-title__HsepI"};

/***/ })

}]);